import { LoadingSpinner } from '@oaknorth/component-core-v2';

export const SuspenseLoading = () => <LoadingSpinner />;
